import React from 'react';
import PropTypes from 'prop-types';

import { Card } from 'antd';

import _s from './ForgotPassword.less';

const EmailSent = props => {
  const { email } = props;

  return (
    <Card className={_s.EmailSentCard} style={{ margin: 'auto' }}>
      <p style={{ fontWeight: 'bold', fontSize: '1.05rem', textAlign: 'center' }}>Email Sent!</p>
      Email sent to {email}! Check your email and reset your password.
    </Card>
  );
};

EmailSent.propTypes = {
  email: PropTypes.string.isRequired
};

export default EmailSent;
